enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.BrandAutocomplete.request',
	receive = 'MedicinalBrandsAnalytics.BrandAutocomplete.receive',
}

export default ActionTypes;
